import React from 'react';
// import { RandomizedUserBadgeColors } from '../../../Constants';
import cross from '../../assets/icons/close.svg';
import warning from '../../assets/icons/Warning.svg';
// import { UsersDetails } from '../Model';
import Modal from '../../CommonComponents/Modal';
import Button from '../../CommonComponents/Button';
import { api } from '../../utils';
import './index.scss';
import Toaster from '../../CommonComponents/Toaster/Toast';
import { UserDisplay } from '../../CommonComponents/UserDisplay';

interface UsersDetails {
  firstName: string;
  lastName: string;
  userEmail: string;
  userId: number;
}
const ExistingAdminsList = (props: {
  tenantId: number;
  usersDetails: UsersDetails[];
  updateTenantInfo: Function;
  buttonTitle: {
    removeAdmin: string;
  };
}) => {
  const tenantRemoveModalData = {
    show: false,
    tenantId: 0,
    user: { firstName: '', lastName: '', userEmail: '', userId: 0 },
  };

  const [toasterMsg, setToasterMsg] = React.useState('');
  const [showRemoveTenantAdmin, setRemoveTenantAdmin] =
    React.useState(tenantRemoveModalData);
  const [deleteWarning, setDeleteWarning] = React.useState(false);
  const [process, setProcess] = React.useState(false);
  const showDeleteWarning = () => {
    return (
      <Modal
        isOpen={true}
        title=''
        onClose={() => setDeleteWarning(false)}
        style={{
          width: '452px',
          height: '218px',
          padding: '8px 0px 30px 30px',
        }}>
        <div
          style={{
            fontSize: '20px',
            color: '#000000',
            marginTop: '15px',
          }}>
          <img src={warning} style={{ marginRight: '4px' }} />
          Can’t remove tenant admin
        </div>
        <div
          style={{
            fontSize: '14px',
            lineHeight: '1.57',
            color: '#000000',
            marginTop: '24px',
            marginRight: '12px',
          }}>
          You must have at least one tenant admin for the tenant. Please add another
          tenant admin before removing this user.
        </div>
      </Modal>
    );
  };

  const removeTenantAdmin = (
    tenantId: number,
    user: UsersDetails,
    updateTenantInfo: Function
  ) => {
    return (
      <Modal
        title='Remove tenant admin'
        isOpen={true}
        onClose={() => setRemoveTenantAdmin(tenantRemoveModalData)}
        // disableCloseButton={process}
      >
        <div className='remove-tenant-container'>
          <div
            style={{
              fontSize: '14px',
              lineHeight: '1.57',
              color: '#000000',
              marginTop: '24px',
            }}>
            Please confirm.{' '}
            <span style={{ fontWeight: 'bold' }}>
              {user.firstName + ' ' + user.lastName}
            </span>{' '}
            will be removed from the role of tenant admin.
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              margin: '24px 0 0',
            }}>
            <Button
              text='Cancel'
              disabled={process}
              theme='secondary-blue'
              onClick={() => setRemoveTenantAdmin(tenantRemoveModalData)}
            />

            <Button
              text={process ? 'Removing...' : props.buttonTitle.removeAdmin}
              disabled={process}
              theme='dark-blue'
              onClick={() => {
                setProcess(true);
                api('removeTenantAdmin', 'POST', {
                  tenantId: props.tenantId,
                  userId: user.userId,
                })
                  .then((data) => {
                    if (data.status === 'Success') {
                      setProcess(false);
                      updateTenantInfo();
                      setRemoveTenantAdmin(tenantRemoveModalData);
                      setToasterMsg('Tenant Admin removed');
                    }
                  })
                  .catch((err) => {
                    setProcess(false);
                    setToasterMsg(err.message);
                  });
              }}
            />
          </div>
        </div>
      </Modal>
    );
  };
  return (
    <div className='existing-admins-list'>
      {props.usersDetails.map((user) => {
        return (
          <div
            className='each-ea-list'
            id={`each-admin-${user.userId}`}
            key={user.userId}>
            <UserDisplay
              disabled={false}
              firstName={user.firstName}
              lastName={user.lastName}
              userEmail={user.userEmail}
            />
            {user.userEmail === sessionStorage.getItem('userEmail') ? null : (
              <div
                className='ea-remove clickable'
                onClick={() => {
                  props.usersDetails.length > 1
                    ? setRemoveTenantAdmin({
                        show: true,
                        tenantId: props.tenantId,
                        user: user,
                      })
                    : setDeleteWarning(true);
                }}>
                <img src={cross} height='20px' alt='' />
              </div>
            )}
          </div>
        );
      })}
      {deleteWarning ? showDeleteWarning() : null}
      {showRemoveTenantAdmin.show
        ? removeTenantAdmin(
            showRemoveTenantAdmin.tenantId,
            showRemoveTenantAdmin.user,
            props.updateTenantInfo
          )
        : null}
      {toasterMsg ? (
        <Toaster
          toastList={{
            description: toasterMsg,
            backgroundColor: 'black',
          }}
          position={'top-center'}
          deleteTime={3000}
        />
      ) : null}
    </div>
  );
};

export default ExistingAdminsList;
